module.exports = __webpack_public_path__ + "img/9788946418769.e5b9bb15.jpg";